import { Route, Switch } from "react-router-dom";
import { Invoicing } from "../modules/Invoicing";
import { Payables } from "../modules/Payables";
import { DeletePayableModal } from "./components/DeletePayableModal/DeletePayableModal";
import { InvoiceActions } from "./components/InvoiceActions/InvoiceActions";
import { PaymentsVerificationModal } from "./components/PaymentsVerificationModal/PaymentsVerificationModal";
import { RejectPayableModal } from "./components/RejectPayableModal/RejectPayableModal";
import { DeductionInfo } from "./screens/deductions/modals/DeductionsInfo";
import { DeleteDeduction } from "./screens/deductions/modals/DeleteDeduction";

export const Invoices = () => {
  return (
    <>
      <PaymentsVerificationModal />
      <InvoiceActions />
      <DeletePayableModal />
      <RejectPayableModal />
      <DeductionInfo />
      <DeleteDeduction />

      <Switch>
        <Route path="/member/invoices/payables" component={Payables} />

        <Route path="/member/invoices" component={Invoicing} />
      </Switch>
    </>
  );
};
